import script from "./CreateActiviLogttery.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateActiviLogttery.vue?vue&type=script&setup=true&lang=ts"

import "./CreateActiviLogttery.vue?vue&type=style&index=0&id=05d0d26e&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d0d26e"]])

export default __exports__